import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { getObjectItem, getTranslation, getPriceList, getPos } from '../../actions/dataActions'
import OpenOrder from './OpenOrder'
import * as general from '../../constants/General'
import * as resource from '../../constants/Resources'

function OpenOrdersOverview(props) {
    const { posid, width, height, top, left, itemparam } = props;
    const [data, setData] = useState({ showOpen: true, orders: [] });
    let style = {
        width: `${width}%`,
        height: `${height}%`,
        top: `${top}%`,
        left: `${left}%`,
        fontSize: `15px`,
        position: 'relative'
    };
    let param = JSON.parse(itemparam);

    function toggleOrders(posid) {
        fetch(`${general.API_URL_GET_ORDEROVERVIEW}${posid}/${!data.showOpen}`).then(result => result.json()).then(orders => prepareData(orders, !data.showOpen));
    }

    function prepareData(data, showOpen = true) {
        var newOrders = [];
        data.forEach(element => {
            element.ReceiptLines.forEach(order => {
                if (order.RegistrationDateTime === undefined || order.RegistrationDateTime === null) {
                    order.RegistrationDateTime = new Date();
                }

                order.openOrder = element;
                newOrders.push(order);
            })
        });
        setData({ showOpen: showOpen, orders: newOrders });
    }


    function updateOverview() {
        fetch(`${general.API_URL_GET_ORDEROVERVIEW}${posid}/${data.showOpen}`).then(result => result.json()).then(orders => prepareData(orders, data.showOpen));
    }

    useEffect(() => {
        fetch(`${general.API_URL_GET_ORDEROVERVIEW}${posid}/${data.showOpen}`).then(result => result.json()).then(orders => prepareData(orders, data.showOpen))
        const interval = setInterval(() => {

            fetch(`${general.API_URL_GET_ORDEROVERVIEW}${posid}/${data.showOpen}`).then(result => result.json()).then(orders => prepareData(orders, data.showOpen))
        }, 5000);
        return () => clearInterval(interval);
    }, [data.showOpen]);

    return (
        <div style={style}>

            <div className="openOrderOverview">
                <table id="OpenOrdersTable" className="OpenOrdersTable">
                    <thead>
                        <tr className="OpenOrdersTableHeader" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            {(param.HidePricelist ? (null) : <th>{props.getTranslation(resource.OPENORDERCOLUMN_PRICELIST)}</th>)}
                            {(param.HideObject ? (null) : <th>{props.getTranslation(resource.OPENORDERCOLUMN_OBJECT)}</th>)}
                            {(param.HideTicket ? (null) : <th>{props.getTranslation(resource.OPENORDERCOLUMN_RECEIPT)}</th>)}
                            {(param.HideCustomer ? (null) : <th>{props.getTranslation(resource.OPENORDERCOLUMN_CUSTOMER)}</th>)}
                            {(param.HideUser ? (null) : <th>{props.getTranslation(resource.OPENORDERCOLUMN_SYSTEMUSER)}</th>)}
                            {(param.HideTime ? (null) : <th>{props.getTranslation(resource.OPENORDERCOLUMN_TIME)}</th>)}
                            <th style={{ width: "5%" }}>{props.getTranslation(resource.OPENORDERCOLUMN_QUANTITY)}</th>
                            <th style={{ width: "25%" }}>{props.getTranslation(resource.OPENORDERCOLUMN_ARTICLE)}</th>
                            {(param.HideConfigurations ? (null) : <th style={{ width: "20%" }}>{props.getTranslation(resource.OPENORDERCOLUMN_CONFIGURATION)}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {(data.orders.sort(function (a,b){return a.RegistrationDateTime - b.RegistrationDateTime}).map(order => <OpenOrder
                            openorder={order.openOrder}
                            receiptline={order}
                            updateCall={updateOverview}
                            registrationDateTime={order.RegistrationDateTime}
                            param={param}
                            showOpen={data.showOpen}
                        />
                        ))}
                    </tbody>
                </table>

            </div>
            <div style={{ position: "absolute", bottom: "10px", right: "10px" }}>
                <button onClick={() => toggleOrders(posid)} id="closedorders" className="btn btn-primary" style={{ width: "50px", height: "50px", borderRadius: "50px", border: "none", backgroundColor: "#3191b0", color: "white", margin: "auto" }}>
                    <i style={{ margin: "auto" }} className="list icon"></i>
                </button>
            </div>
        </div>
    )


}

function mapStateToProps(state) {
    return {
        receipt: state.receiptState.receipt,
        posid: state.generalState.posId
    }
}

export default connect(mapStateToProps, { getObjectItem, getTranslation, getPriceList, getPos })(OpenOrdersOverview)








// WEBPACK FOOTER //
// src/freeformat/components/OpenOrdersOverview.jsx